import { Booking, Product } from "../types/booking";
import { getBookingProducts } from "./agentBookingMetrics";

export interface AgentContainerProductRow extends Product {
  booking_id: number;
}

export const getContainerProductsFromBookings = (
  bookings: Booking[]
): AgentContainerProductRow[] =>
  bookings.flatMap((booking) =>
    getBookingProducts(booking).map((product) => ({
      ...product,
      booking_id: product.booking_id ?? booking.id,
    }))
  );

export interface ContainerProductTotals {
  products: number;
  cartons: number;
  cbm: number;
  grossWeightKg: number;
}

export const getContainerProductTotals = (
  bookings: Booking[]
): ContainerProductTotals => {
  const products = getContainerProductsFromBookings(bookings);
  return {
    products: products.length,
    cartons: products.reduce((sum, p) => sum + (p.cartons || 0), 0),
    cbm: products.reduce((sum, p) => sum + (p.cbm || 0), 0),
    grossWeightKg: products.reduce((sum, p) => sum + (p.gross_weight || 0), 0),
  };
};
